import {PolyDictionary} from '../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {removeImportExport} from '../../../@polygonjs/polygonjs/src/core/ImportUtils';
import {ManifestContent} from '../../../@polygonjs/polygonjs/src/engine/io/manifest/import/SceneData';
import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {ModuleName} from '../../../@polygonjs/polygonjs/src/engine/poly/registers/modules/Common';
import {CoreFileUtils} from '../core/FileUtils';
import _ from 'lodash';

// @ts-ignore
import BUNDLED_TYPES from '../../engine/types/bundled_types.d.ts.txt';
import {PolyNodeDataRegister} from '../../../@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeDataRegister';
import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';

interface OptimizedLoadSceneTemplateOptions {
	elementId: string;
	manifestContent: ManifestContent;
	assetsManifest: PolyDictionary<string>;
	ALL_IMPORT_PATH: string;
	POLY_NODES_DATA: PolyNodeDataRegister<NodeContext>[];
}

export class FilesRegister {
	protected static _polygonjs: string;
	protected static _polygonjsLicense: string;
	// protected static _polygonjsBundledTypes: string;
	// protected static _viewer: string;
	protected static _sceneDataLoader: string;
	protected static _moduleContentByName: Map<ModuleName, string> = new Map();
	protected static _moduleLicenseContentByName: Map<ModuleName, string> = new Map();
	protected static _thumbnailStaticBlob: Blob | undefined;
	protected static _optimizedLoadScene: string;

	private static _initialized = false;
	static async init() {
		if (this._initialized) {
			return;
		}
		this._initialized = true;
		// @ts-ignore
		const POLYGONJS = await import(`!!raw-loader!../../../@polygonjs/polygonjs/dist/all.js?v=2`);
		this._polygonjs = (POLYGONJS as any).default;
		// @ts-ignore
		const POLYGONJS_LICENSE = await import(`!!raw-loader!../../../@polygonjs/polygonjs/dist/all.js.LICENSE.txt`);
		this._polygonjsLicense = (POLYGONJS_LICENSE as any).default;
		// @ts-ignore
		// const bundledTypes = await import('raw-loader!../../../dist/bundled_types.d.ts.txt');
		// this._polygonjsBundledTypes = bundledTypes as any;
		// console.log('A this._polygonjsBundledTypes');
		// console.log(this._polygonjsBundledTypes);
		// console.log('B this._polygonjsBundledTypes');

		// @ts-ignore
		// const VIEWER = await import('raw-loader!../../../@polygonjs/polygonjs/dist/viewer.js');
		// this._viewer = (VIEWER as any).default;
		// @ts-ignore
		const SCENE_DATA_LOADER = await import('raw-loader!../../../@polygonjs/polygonjs/dist/sceneDataLoader.js');
		this._sceneDataLoader = (SCENE_DATA_LOADER as any).default;
		// @ts-ignore
		const OPTIMIZED_LOAD_SCENE = await import('raw-loader!./templates/OptimizedLoad.ts');
		this._optimizedLoadScene = removeImportExport(OPTIMIZED_LOAD_SCENE.default);

		this._loadThumbnailstaticBlob();
	}

	private static _polyConfig: string | undefined;
	static polyConfig() {
		return this._polyConfig;
	}
	static async registerPolyConfig(url: string) {
		const response = await fetch(url);
		const text = await response.text();
		this._polyConfig = text;
	}
	static optimizedLoadScene(options: OptimizedLoadSceneTemplateOptions) {
		const {elementId, manifestContent, assetsManifest, ALL_IMPORT_PATH, POLY_NODES_DATA} = options;

		const assetsMap = JSON.stringify(assetsManifest, null, 2);
		const manifestContentStr = JSON.stringify(manifestContent, null, 2);
		const POLY_LIB_ROOT = Poly.libs.root() || '';

		// console.log(_.templateSettings.interpolate, _.templateSettings);
		// const prevInterpolate = _.templateSettings.interpolate;
		// _.templateSettings.interpolate = undefined;
		const compileFileContent = _.template(this._optimizedLoadScene)({
			elementId,
			ALL_IMPORT_PATH,
			POLY_LIB_ROOT,
			// assetsMap,
			// manifestContent: manifestContentStr,
			moduleName: 'moduleNameReallyShouldNotBeReplaced',
		})
			// we use .replace as we need to remove the single quotes (')
			.replace("'___ASSETS_MAP___'", assetsMap)
			.replace("'___MANIFEST_CONTENT___'", manifestContentStr)
			.replace("'___POLY_NODES_DATA___'", JSON.stringify(POLY_NODES_DATA));
		//.replace(/\/\/ @ts-ignore/g, '')
		//.replace(/\s/g, '\t');

		// _.templateSettings.interpolate = prevInterpolate;
		return compileFileContent;

		// 	this._optimizedLoadScene
		// 		.replace('${elementId}', elementId)
		// 		.replace('${ALL_IMPORT_PATH}', ALL_IMPORT_PATH)
		// 		.replace('${POLY_LIB_ROOT}', Poly.libs.root() || '')
		// 		.replace("'${assetsMap}'", JSON.stringify(assetsManifest, null, 2))
		// 		// Be careful here, as the single quotes are also part of what is replaced
		// 		.replace("'${manifestContent}'", JSON.stringify(manifestContent, null, 2))
		// );
	}

	static polygonjs() {
		return this._polygonjs;
	}
	static polygonjsLicense() {
		return this._polygonjsLicense;
	}
	static polygonjsBundledTypes() {
		return BUNDLED_TYPES;
	}
	// static viewer() {
	// 	return this._viewer;
	// }
	static sceneDataLoader() {
		return this._sceneDataLoader;
	}
	static module(moduleName: ModuleName) {
		return this._moduleContentByName.get(moduleName);
	}
	static moduleLicense(moduleName: ModuleName) {
		return this._moduleLicenseContentByName.get(moduleName);
	}

	//
	//
	// THUMBNAIL STATIC BLOB
	//
	//
	private static async _loadThumbnailstaticBlob() {
		const elementId = 'thumbnail_static_for_self_contained_export';
		const image = document.getElementById(elementId) as HTMLImageElement;
		if (!image) {
			// no need for a warning here,
			// as the element will not be present for the local app
			// console.log('❌ no image to load thumbnail blob from');
			return;
		}
		const url = image.src;
		try {
			const blob = await CoreFileUtils.imageUrlToBlob(url);
			// console.log(url);
			// const image = new Image();
			// image.onload = () => {
			// 	// const response = await fetch(url, {mode: 'no-cors'});
			// 	// const blob = await response.blob();

			// 	document.body.innerHTML = '';
			// 	document.body.append(image);
			if (blob) {
				// const datauri = await CoreFileUtils.blobToDatauri(blob);
				// document.body.innerHTML = `<img src="${datauri}"></img>`;
				this.setThumbnailStaticBlob(blob);
				// console.log('✅ registered thumbnail blob');
			}
			// };
			// image.src = url;
		} catch (err) {
			console.log('FilesRegister: thumbnail not found at url', url);
		}
	}
	static setThumbnailStaticBlob(blob: Blob) {
		this._thumbnailStaticBlob = blob;
	}
	static thumbnailStaticBlob() {
		return this._thumbnailStaticBlob;
	}
}
